import FinishProposalUserData from './FinishProposalUserData';

export default FinishProposalUserData;
